import { downloadFile, generateBlob } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { frameworkDownloadDocument, getDocumentsFrameworkAgreement } from '../../services/frameworkAgreement'

export const FRAMEWORK_AGREEMENT_DOCUMENTS = 'FRAMEWORK_AGREEMENT_DOCUMENTS'
export const FRAMEWORK_AGREEMENT_DOCUMENTS_ERROR = 'FRAMEWORK_AGREEMENT_DOCUMENTS_ERROR'
export const FRAMEWORK_AGREEMENT_DOCUMENTS_SUCCESS = 'FRAMEWORK_AGREEMENT_DOCUMENTS_SUCCESS'
export const onFrameworkAgreementDocuments = makeActionCreator(FRAMEWORK_AGREEMENT_DOCUMENTS)
export const onFrameworkAgreementDocumentsSuccess = makeActionCreator(FRAMEWORK_AGREEMENT_DOCUMENTS_SUCCESS, 'payload')
export const onFrameworkAgreementDocumentsError = makeActionCreator(FRAMEWORK_AGREEMENT_DOCUMENTS_ERROR)
export const onFrameworkAgreementDocumentsThunk = payload => async dispatch => {
  dispatch(onFrameworkAgreementDocuments())

  try {
    const { data } = await getDocumentsFrameworkAgreement({
      actionType: FRAMEWORK_AGREEMENT_DOCUMENTS,
      dni: payload.userType === 'Comprador' ? payload.dni : undefined
    })

    return dispatch(
      onFrameworkAgreementDocumentsSuccess({
        frameworkAgreements: data?.payload?.map(document => {
          return {
            name: document.nombreConvenioMarco,
            documents: document.documentos.map(doc => {
              return {
                documentId: doc.folio,
                documentExtension: doc.extension,
                documentName: doc.nombreArchivo,
                documentType: doc.nombreTipoDocumento,
                receptionDate: doc.fechaRecepcion
              }
            })
          }
        })
      })
    )
  } catch (error) {
    return dispatch(onFrameworkAgreementDocumentsError())
  }
}

export const FRAMEWORK_DOWNLOAD_DOCUMENT = 'FRAMEWORK_DOWNLOAD_DOCUMENT'
export const FRAMEWORK_DOWNLOAD_DOCUMENT_ERROR = 'FRAMEWORK_DOWNLOAD_DOCUMENT_ERROR'
export const FRAMEWORK_DOWNLOAD_DOCUMENT_SUCCESS = 'FRAMEWORK_DOWNLOAD_DOCUMENT_SUCCESS'
export const onFrameworkDownloadDocument = makeActionCreator(FRAMEWORK_DOWNLOAD_DOCUMENT, 'payload')
export const onFrameworkDownloadDocumentError = makeActionCreator(FRAMEWORK_DOWNLOAD_DOCUMENT_ERROR, 'payload')
export const onFrameworkDownloadDocumentSuccess = makeActionCreator(FRAMEWORK_DOWNLOAD_DOCUMENT_SUCCESS, 'payload')
export const onFrameworkDownloadDocumentThunk = payload => async dispatch => {
  dispatch(onFrameworkDownloadDocument({ id: payload.id }))

  try {
    const { data, headers } = await frameworkDownloadDocument({ id: payload.id })
    const blob = generateBlob(data, headers['content-type'])

    downloadFile(blob, payload.filename)

    return dispatch(onFrameworkDownloadDocumentSuccess({ id: payload.id }))
  } catch (error) {
    return dispatch(onFrameworkDownloadDocumentError({ error, id: payload.id }))
  }
}
